import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import LicenseeReturnHeader from "./LicenseeReturnHeader";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import {
  loadLicenseeReturnAsync,
  selectLicenseeReturn,
} from "../../../redux/slices/licenseeReturn";
import LicenseeReturnDetails from "./LicenseeReturnDetails";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { ComplianceInvestigationBox } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationBox";
import Page500 from "../../../pages/auth/Page500";

const LicenseeReturn = () => {
  const [loading, setLoading] = useState(false);
  const [loadingLicenseeReturnId, setLoadingLicenseeReturnId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const licenseeReturnSelector = useAppSelector(selectLicenseeReturn);

  const dispatch = useAppDispatch();

  let { profileNo, licenseeReturnId } = useParams();
  if (!profileNo || !licenseeReturnId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingLicenseeReturnId !== licenseeReturnId) {
    setLoadingLicenseeReturnId(licenseeReturnId);
    dispatch(loadLicenseeReturnAsync(licenseeReturnId));
    return <Loading />;
  }

  const licenseeReturn = licenseeReturnSelector.licenseeReturn;

  if (licenseeReturnSelector.fetchStatus !== "idle") {
    return <Loading />;
  }

  if (!licenseeReturn) {
    return <Page404 />;
  }

  if (!licenseeReturn.response.ok) {
    if (licenseeReturn.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenseeReturnHeader licenseeReturn={licenseeReturn} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenseeReturnDetails licenseeReturn={licenseeReturn} />
        </Col>
      </Row>
      {licenseeReturn.complianceInvestigationDetails && (
        <Row>
          <Col className="col-12 col-sm-12 col-md-12">
            <ComplianceInvestigationBox
              complianceInvestigationDetails={
                licenseeReturn.complianceInvestigationDetails
              }
              licenceProfile={licenceProfile}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            licenceProfile={licenceProfile}
            licenseeReturn={licenseeReturn}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        licenseeReturn={licenseeReturn}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default LicenseeReturn;
